import { GridColDef } from '@mui/x-data-grid';
import Table from '../custom/Table';
import Title from '../custom/Title';
import DynamicForm from '../forms/DynamicForm';
import { BILLING_BLOTTER_FIELDS, SEARCH_BILLING_BLOTTER_FIELDS } from '../../Models/BlotterTables';
import { Button } from '@mui/material';

export const BillingBlotter = () => {

    const config = SEARCH_BILLING_BLOTTER_FIELDS

    const getBillingBlotterColumns = (): GridColDef<any>[] => {
        let minWidth = 100
        return BILLING_BLOTTER_FIELDS.map(field => {
            switch (field.id) {
                case "totalPending":
                    minWidth = 140
                    break;
                case "agingInDays":
                    minWidth = 160
                    break;
                case "customerName":
                    minWidth = 150
                    break;
                case "billingNo":
                    minWidth = 150
                    break;
                case "gtTransactionType":
                    minWidth = 180
                    break;

                default:
                    minWidth = 100
                    break;
            }

            return {
                field: field.id,
                headerName: field.label,
                minWidth
            }
        })
    }

    const BillingBlotterRows = [{ id: 1 }]
    const submitHandler = (data: any): any => {
        console.log(data)
    }
    return (
        <div style={{ padding: '0 10px' }}>
            <div style={{ borderBottom: '1px solid #d8d8d8' }}>
                <Title style={{ textAlign: 'left', margin: '20px 10px 10px 10px', color: '#7f7d76' }}>Billing Blotter</Title>
            </div>
            <div style={{ padding: '20px 0px' }}>
                <DynamicForm config={config} onSubmit={submitHandler} submitText='Search' onCancel={() => { }} cancelText='Clear Filter' />
            </div>
            <Table columns={getBillingBlotterColumns()} rows={BillingBlotterRows} />
            <div style={{ paddingTop: "30px" }}>
                <Button variant='contained' type='submit'>{'Fund Allocation'}</Button>
            </div>
        </div>
    )
}
